export const featureFlags = (state = {}, action) => {
    switch (action.type) {
        case 'SET_FEATURE_FLAGS':
            return action.featureFlags
        default:
            return state;
    }
};

export const getFeatureFlags = (state) => state;
